export default "__VITE_ASSET__41b73c2d__"